import { useTranslation } from "next-i18next";
import Link from "next/link";

const SubjectsComponent = ({ articleForCategory, locale }) => {

    const { t } = useTranslation("common");

    return (
        <div className="p-8">
            <h2 className="pb-8 text-2xl font-semibold text-black">{t("help:subjects")}</h2>

            {articleForCategory.map((item, index) => (
                <div key={index} className="pb-4">
                    <Link href={`/${locale === 'tr' ? 'yardim' : 'help'}/${item?.category.slug}`}>
                        <h3 className="text-textGray2 hover:text-orange-500">{item?.category.title}</h3>
                    </Link>
                    {item.article.length > 0 && (
                        <div className="pt-2 pl-8">
                            {item.article.map((article, subIndex) => (
                                <Link
                                    key={subIndex}
                                    href={`/${locale === 'tr' ? 'yardim' : 'help'}/${item?.category.slug}/${article?.connection_id}/${article?.slug}`}
                                >
                                    <div className="p-2 text-textGray2 hover:text-orange-500"> {article.title}</div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}

export default SubjectsComponent